import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { ActivityGridComponent } from '../qms/activity-grid/activity-grid.component';
import { AuService } from '../qms/au/au.service';
import { AppService } from '../app.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})

export class MenuItemComponent {

  @Input() items: NavItem[];
  @ViewChild('childMenu') public childMenu: any;

  constructor(public router: Router, private readonly message: messageService, public qualityService: qmsService,
    public activityGridComponent: ActivityGridComponent, public appService: AppService,
    public auService: AuService) {
  }

  clicked(data: any) {


  }
  secondLevel(firstChild: string, child: any) {
    console.log(firstChild, child);
    this.qualityService.showTopNav = false;
    if (child == null && this.message.breadcrumbData.firstLevel == 'Logs') {
      console.log(firstChild, child, "2");
      this.message.breadcrumbData.secondLevel = firstChild;
      this.message.breadcrumbData.thirdLevel = null;
      this.message.breadcrumbData.fourthLevel = null;
    } else if (child == null) {
      console.log(firstChild, child, "1");
      this.message.breadcrumbData.thirdLevel = firstChild;
      this.message.breadcrumbData.fourthLevel = null;
    } else if (child.length == 0) {
      console.log(firstChild, child, "3");
      this.message.breadcrumbData.secondLevel = firstChild;
      this.message.breadcrumbData.thirdLevel = null;
      this.message.breadcrumbData.fourthLevel = null;
    } else if (child.length > 0) {
      console.log(firstChild, child, "4");
      this.message.breadcrumbData.secondLevel = firstChild;
      this.message.breadcrumbData.fourthLevel = null;
    }
    this.navigationMethod(this.message.breadcrumbData.firstLevel, this.message.breadcrumbData.secondLevel, this.message.breadcrumbData.thirdLevel);
  }

  navigationMethod(firstLevel: string, secondLevel: string, thirdLevel: string) {

    console.log(firstLevel, secondLevel);
    if (firstLevel == 'My Tasks') {
      this.message.isMyTaskFromDashboard = false;
      this.router.navigate(['/dashboard/MyTasks']);
    } else if (firstLevel == 'Dashboard') {
      this.router.navigate(['/dashboard/OneQMSDashboard']);
    } else if (thirdLevel == null) {
      /* Maintain level two menu navigation here */
      if (secondLevel == 'Manage Trainings') {
        this.router.navigate(['/dashboard/manageTraining/Manage']);
      } else if (secondLevel == 'FlexiFields') {
        this.router.navigate(['/dashboard/flexfieldSetup']);
        this.appService.flexiFieldModule = "mainPage";
      } else if (secondLevel == 'User Management') {
        this.router.navigate(['/dashboard/users']);
      } else if (secondLevel == 'Codelists') {
        this.router.navigate(['/dashboard/codelists']);
      } else if (secondLevel == 'Document Types') {
        this.router.navigate(['/dashboard/documenttype']);
      } else if (secondLevel == 'Product Master') {
        this.router.navigate(['/dashboard/productMaster']);
      } else if (secondLevel == 'Instrument Master') {
        this.router.navigate(['/dashboard/instrument-master']);
      } else if (secondLevel == 'Vendors') {
        this.router.navigate(['/dashboard/vendors']);
      } else if (secondLevel == 'Training Review Period') {
        this.router.navigate(['/dashboard/trainingReviewPeriod']);
      } else if (secondLevel == 'My Trainings') {
        this.router.navigate(['/dashboard/trainingDashboard']);
      } else if (secondLevel == 'Repository') {
        this.router.navigate(['/dashboard/rootFolder']);
      } else if (secondLevel == 'Organization Profile') {
        this.router.navigate(['/dashboard/oneqmsOrganization']);
      } else if (secondLevel === 'Printer') {
        this.router.navigate(['/dashboard/organisation-printers']);
      } else if (secondLevel == 'Business Areas') {
        this.router.navigate(['/dashboard/qmsBusinessArea']);
      } else if (secondLevel == 'Reports' && firstLevel != 'Admin' && firstLevel != 'Documents' && firstLevel != 'Logs') {
        this.router.navigate(['/dashboard/tmsReport']);
      } else if (secondLevel == 'Reports' && firstLevel == 'Logs') {
        this.router.navigate(['/dashboard/FormsAndLogsReports']);
      } else if (secondLevel == 'Instructor Trainings') {
        this.router.navigate(['/dashboard/scheduledTrainings']);
      } else if (secondLevel == 'Training Badge') {
        this.router.navigate(['/dashboard/trainingBadge']);
      } else if (secondLevel == 'Schedulers') {
        this.router.navigate(['/dashboard/schedulers']);
      } else if (secondLevel == 'Reports' && firstLevel == 'Admin') {
        this.router.navigate(['/dashboard/OneQmsAdminReportComponent']);
      } else if (secondLevel == 'Reports' && firstLevel == 'Documents') {
        this.router.navigate(['/dashboard/DmsMainReportComponent']);
      } else if (secondLevel == 'Risk') {
        this.router.navigate(['/dashboard/riskSettingsComponent']);
      } else if (secondLevel == 'Location Master') {
        this.router.navigate(['/dashboard/locationMasterComponent']);
      } else if (secondLevel == 'Issuance Tracking') {
        this.router.navigate(['/dashboard/documentIssuanceHistory']);
      } else if (secondLevel == 'Destruction Tracking') {
        this.router.navigate(['/dashboard/documentDestructionsHistory']);
      } else if (secondLevel == 'Search') {
        this.router.navigate(['/dashboard/subFolder/Search']);
      } else if (secondLevel == 'Register') {
        this.router.navigate(['/dashboard/register']);
      } else if (secondLevel == 'Create') {
        this.router.navigate(['/dashboard/createOrg/Create']);
      } else if (secondLevel == 'Upgrade') {
        this.router.navigate(['/dashboard/createOrg/Upgrade']);
      } else if (secondLevel == 'Manage') {
        this.router.navigate(['/dashboard/manageOrg']);
      } else if (secondLevel == 'DR Mode') {
        this.router.navigate(['/dashboard/drMode']);
      }
      /* Maintain level three menu navigation here */
    } else if (thirdLevel == 'Quality' && secondLevel == 'Module') {
      this.router.navigate(['/dashboard/qmsSettings']);
    } else if (secondLevel == 'Module' && thirdLevel == 'Documents') {
      this.router.navigate(['/dashboard/dmsSettings']);
    } else if (secondLevel == 'Module' && thirdLevel == 'Trainings') {
      this.router.navigate(['/dashboard/tmsSettings']);
    } else if (thirdLevel == 'Quality' && secondLevel == 'Groups') {
      this.router.navigate(['/dashboard/qmsGroups']);
    } else if (thirdLevel == 'Manage' && secondLevel == 'Change Request') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CR";
      this.qualityService.moduleName = "CR";
      this.activityGridComponent.ngOnInit();
      this.qualityService.activityTitle = secondLevel;
      console.log('changeRequestCode - ', this.message.changeRequestCode);
      this.router.navigate(['/dashboard/ActivityCR', "CR"]);
    } else if (thirdLevel == 'Manage' && secondLevel == 'CAPA') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CAPA";
      this.qualityService.moduleName = "CAPA";
      this.activityGridComponent.ngOnInit();
      this.qualityService.activityTitle = secondLevel;
      this.router.navigate(['/dashboard/ActivityCR', "CAPA"]);
    } else if (thirdLevel == 'Manage' && secondLevel == 'Deviation') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.refereshBreadCrumb = false;
      this.message.changeRequestCode = "DV";
      this.qualityService.moduleName = "DV";
      this.activityGridComponent.ngOnInit();
      this.qualityService.activityTitle = secondLevel;
      this.router.navigate(['/dashboard/ActivityCR', "DV"]);
    } else if (thirdLevel == 'Manage' && secondLevel == 'Incident') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.refereshBreadCrumb = false;
      this.message.changeRequestCode = "IN";
      this.qualityService.moduleName = "IN";
      this.activityGridComponent.ngOnInit();
      this.qualityService.activityTitle = secondLevel;
      this.message.showIncidentSwitch = false;
      this.router.navigate(['/dashboard/ActivityCR', "IN"]);
    } else if (thirdLevel == 'Manage' && secondLevel == 'Quality Issue') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.refereshBreadCrumb = false;
      this.message.changeRequestCode = "QI";
      this.qualityService.moduleName = "QI";
      this.activityGridComponent.ngOnInit();
      this.qualityService.activityTitle = secondLevel;
      this.router.navigate(['/dashboard/ActivityCR', "QI"]);
    } else if (thirdLevel == 'Manage' && secondLevel == 'Customer Complaint') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CC";
      this.qualityService.moduleName = "CC";
      this.activityGridComponent.ngOnInit();
      this.qualityService.activityTitle = secondLevel;
      this.message.showComplaintSwitch = false;
      this.router.navigate(['/dashboard/ActivityCR', "CC"]);
    } else if (thirdLevel == 'Training Parameters') {
      this.router.navigate(['/dashboard/trainingParameterTemplate']);
    } else if (thirdLevel == 'Document Download') {
      this.router.navigate(['/dashboard/documentDownloadTemplate']);
    }
    else if (secondLevel == 'Templates' && thirdLevel == 'Documents') {
      this.router.navigate(['/dashboard/documentTemplates']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'Document Report Headers') {
      this.router.navigate(['/dashboard/reportHeaderTemplate']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'OOS/OOT Lab Investigation') {
      this.router.navigate(['/dashboard/lab-investigation-template']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'Impact Assessment') {
      this.router.navigate(['/dashboard/impact-assessment-template']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'CheckList') {
      this.router.navigate(['/dashboard/checklist-template']);
    } else if (thirdLevel == 'Reason for Signatures') {
      this.router.navigate(['/dashboard/reasonForSignatureTemplate']);
    } else if (secondLevel == 'Groups' && thirdLevel == 'Documents') {
      this.router.navigate(['/dashboard/groups']);
    } else if (secondLevel == 'Groups' && thirdLevel == 'Trainings') {
      this.router.navigate(['/dashboard/trainingGroups']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'Reports') {
      this.router.navigate(['/dashboard/qmsReportTemplate']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'Questionnaire') {
      this.router.navigate(['/dashboard/qmsQuestionnaireTemplate']);
    } else if (secondLevel == 'Templates' && thirdLevel == 'Investigation Technique') {
      this.router.navigate(['/dashboard/investigationTechniqueTemplateComponent']);
    } else if (secondLevel == 'Incident' && thirdLevel == 'Raise') {
      this.message.showIncidentSwitch = true;
      this.router.navigate(['/dashboard/raiseIn']);
    } else if (secondLevel == 'User Trainings' && thirdLevel == 'Manage') {
      this.router.navigate(['/dashboard/TmsUserManageTrainingsReport']);
    } else if (secondLevel == 'User Trainings' && thirdLevel == 'Review') {
      this.router.navigate(['/dashboard/TmsUserTrainingReviewPeriodComponent']);
    } else if (secondLevel == 'Customer Complaint' && thirdLevel == 'Raise') {
      this.message.showComplaintSwitch = true;
      this.router.navigate(['/dashboard/raiseCc']);
    } else if (secondLevel == 'Audit' && thirdLevel == 'Master') {
      this.router.navigate(['/dashboard/auMaster']);
    } else if (secondLevel == 'Audit' && thirdLevel == 'Manage') {
      this.qualityService.isTriggeredFromDependencies = false;
      this.qualityService.cancelButtonFrom = "Activity";
      this.auService.auditPageFrom = "Main";
      this.router.navigate(['/dashboard/au']);
      this.message.changeRequestCode = "AU";
      this.qualityService.moduleName = "AU";
    } else if (secondLevel == 'Audit' && thirdLevel == 'Vendors') {
      this.router.navigate(['/dashboard/vendors']);
    } else if (thirdLevel == 'Reports' && secondLevel == 'Change Request') {
      this.message.changeRequestCode = "CR";
      this.qualityService.moduleName = "CR";
      this.router.navigate(['/dashboard/ActivityReportComponent', "CR"]);
    } else if (thirdLevel == 'Reports' && secondLevel == 'CAPA') {
      this.message.changeRequestCode = "CAPA";
      this.qualityService.moduleName = "CAPA";
      this.router.navigate(['/dashboard/ActivityReportComponent', "CAPA"]);
    }
    else if (thirdLevel == 'Reports' && secondLevel == 'Deviation') {
      this.message.changeRequestCode = "DV";
      this.qualityService.moduleName = "DV";
      this.router.navigate(['/dashboard/ActivityReportComponent', "DV"]);
    } else if (thirdLevel == 'Reports' && secondLevel == 'Incident') {
      this.message.changeRequestCode = "IN";
      this.qualityService.moduleName = "IN";
      this.router.navigate(['/dashboard/ActivityReportComponent', "IN"]);
    } else if (thirdLevel == 'Reports' && secondLevel == 'Quality Issue') {
      this.message.changeRequestCode = "QI";
      this.qualityService.moduleName = "QI";
      this.router.navigate(['/dashboard/ActivityReportComponent', "QI"]);
    } else if (thirdLevel == 'Reports' && secondLevel == 'Audit') {
      this.message.changeRequestCode = "AU";
      this.qualityService.moduleName = "AU";
      this.router.navigate(['/dashboard/ActivityReportComponent', "AU"]);
    } else if (thirdLevel == 'Reports' && secondLevel == 'Customer Complaint') {
      this.message.changeRequestCode = "CC";
      this.qualityService.moduleName = "CC";
      this.router.navigate(['/dashboard/ActivityReportComponent', "CC"]);
    } else if (thirdLevel == 'Documents' && secondLevel == 'Notifications') {
      this.router.navigate(['/dashboard/dmsNotificationSettings']);
    } else if (thirdLevel == 'Trainings' && secondLevel == 'Notifications') {
      this.router.navigate(['/dashboard/tmsNotificationSettings']);
    } else if (thirdLevel == 'Quality' && secondLevel == 'Notifications') {
      this.router.navigate(['/dashboard/qmsNotificationSettings']);
    } else if (thirdLevel == "Training Certificates") {
      this.router.navigate(['/dashboard/trainingCertificateTemplate']);
    } else if (thirdLevel == "Forms and Logs") {
      this.router.navigate(['/dashboard/formsAndLogsTemplate']);
    } else if (thirdLevel == "Forms Setup") {
      this.router.navigate(['/dashboard/businessArea/businessProcessForm']);
    } else if (thirdLevel == "Workflows") {
      this.router.navigate(['/dashboard/businessArea/workflow']);
    } else if (thirdLevel == "Execution Setup") {
      this.router.navigate(['/dashboard/businessArea/executionSetup']);
    } else if (thirdLevel == "Feedback") {
      this.router.navigate(['/dashboard/feedbackTemplate']);
    }
  }

}
export interface NavItem {
  name: string;
  children?: NavItem[];
}